import { useQuery } from '@tanstack/react-query';
import { reportsApi } from 'sectors/pilates/reports/api/reportsApi';

export function useTrainerOverview({ trainerId, from, to } = {}) {
  const enabled = Boolean(trainerId) && Boolean(from) && Boolean(to);

  return useQuery({
    queryKey: ['trainerOverview', trainerId, from, to],
    enabled,
    queryFn: () => reportsApi.getTrainerOverview({ trainerId, from, to }),
    // UI daha stabil olsun
    staleTime: 30_000,
    gcTime: 5 * 60_000,
    refetchOnWindowFocus: false,
  });
}
